module.exports = __webpack_public_path__ + "img/8aWiT2hLHXqVwxfB8tf_i.d2ff7448.svg";